import script from "./ImageRectOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageRectOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ImageRectOutline.vue?vue&type=style&index=0&id=9cc8a4b0&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc8a4b0"]])

export default __exports__